import { render, staticRenderFns } from "./CloudVideo.vue?vue&type=template&id=386791fb&scoped=true&"
import script from "./CloudVideo.vue?vue&type=script&lang=ts&"
export * from "./CloudVideo.vue?vue&type=script&lang=ts&"
import style0 from "./CloudVideo.vue?vue&type=style&index=0&id=386791fb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386791fb",
  null
  
)

export default component.exports